<template>
  <div id="target-area" class="target-vue">
    <RouterView />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>
